export default __webpack_public_path__ + "static/media/dstreak.dac8b8f9.png";